import React, { useEffect, useState } from "react";
import SC from "./style";
import {
  AccessDeniedMessage,
  Breadcrumbs,
  Button,
  InnoTable,
} from "InnoUI/components";
import { useNavigate } from "react-router";
import theme from "theme";
import { apiGet, apiPost } from "api/callApi";
import { innoTableConfig, InnoTableDefaultPageSize } from "utils/config";
import { useSearchParams } from "react-router-dom";
import AddUpdateRevision from "./AddUpdateRevision";
import GetPermission from "./FileDetailsView/GetPermission";
import { userAccessType } from "utils/lookUpTable";
import {
  checkUserPermission,
  formatFileSize,
  readFromSessionStorage,
  showAlert,
} from "utils/helper";
import TimezoneConverter from "components/TimeZoneConvertor";
import CustomBreadcrumb from "components/CustomBreadcrumb";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { addCart } from "@store/cart/actions";
import CheckPermissionWrapper from "components/CheckPermissionWrapper";
import OccupantFilterDropdown from "components/OccupantFilterDropdown";
import PointIdIndicator from "components/PointIdIndicator";
import FileTypeIcon from "components/FileTypeIcon";
import dayjs from "dayjs";

const ListFileAndPermission = () => {
  const [fileData, setFileData] = useState([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get("projectId");
  const folderId = searchParams.get("folderId");
  const type = searchParams.get("type");
  const fileId = searchParams.get("fileId");
  const [openModalView, setOpenModalView] = useState(false);
  const [modalRowData, setModalRowData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [hideButtons, setHideButtons] = useState(false);
  const [isdefault, setIsDefault] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(InnoTableDefaultPageSize.pageSize);
  const dispatch = useDispatch();

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || [],
  );

  const getPerFileData = async () => {
    try {
      setIsLoading(true);
      const response = await apiPost(
        `/v1/options/checkpermissions`,
        {
          folderId: folderId,
        },
        false,
      );

      // setFileData(response.data);
      setIsLoading(false);
    } catch (error) {
      console.log("Error", error);
      setIsLoading(false);
    }
  };

  const getFileData = async () => {
    try {
      setIsLoading(true);
      const response = await apiGet(`/v1/file/getFiles/${folderId}`, false);

      let files = response.data || [];

      // if (fileId) {
      //   const index = files.findIndex((file) => file.id == fileId);
      //   if (index > -1) {
      //     const [targetFile] = files.splice(index, 1);
      //     files = [targetFile, ...files];
      //   }
      // }

      setFileData(files);
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const redirectUrl = readFromSessionStorage("submitSend");
    if (redirectUrl) {
      sessionStorage.removeItem("submitSend"); // Clear it to avoid looping
      navigate(redirectUrl);
    }
  }, []);

  useEffect(() => {
    getFileData();
    getPerFileData();
  }, [folderId, type, isdefault]);

  const onAddDataCallback = () => {
    setIsEditing(false);
  };

  const onRowClick = (data) => {
    setIsEditing(true);
  };

  const handlelevelClick = (data) => {
    navigate(
      `/document/file-details?projectId=${projectId}&fileId=${data.id}&parentId=${data.parentId}&folderId=${data.folderId}&type=${type}`,
    );
  };

  const extractDate = (str) => {
    if (!str) return null;

    // Try parsing full string (handles many formats)
    let d = dayjs(str);

    if (d.isValid()) return d.valueOf();

    // Try extracting date-like patterns (fallback)
    const match = str.match(
      /\d{1,2}[-\/ ]\w+[-\/ ]\d{2,4}|\w+ \d{1,2},? \d{4}|\d{4}[-\/ ]\d{1,2}[-\/ ]\d{1,2}/,
    );

    if (match) {
      d = dayjs(match[0]);
      if (d.isValid()) return d.valueOf();
    }

    return null;
  };

  const subColumnData = [
    {
      title: "S.No.",
      dataIndex: "id",
      width: 50,
      render(value, record, index) {
        const serialNumber = (currentPage - 1) * pageSize + index + 1;
        return <p>{serialNumber}</p>;
      },
    },

    {
      title: "Ingested",
      width: 50,
      dataIndex: "pointId",
      render(value, record) {
        return <PointIdIndicator knowledgeStatus={record?.knowledgeStatus} />;
      },
    },

    {
      title: "File Name",
      dataIndex: "subject",
      //sorter: (a, b) => a.fileName.localeCompare(b.fileName),
      sorter: (a, b) => {
        const dateA = extractDate(a.subject);
        const dateB = extractDate(b.subject);

        // Case 1: both have valid dates → sort by date
        if (dateA && dateB) {
          return dateA - dateB;
        }

        // Case 2: only one has date → prioritize dated ones
        if (dateA) return -1;
        if (dateB) return 1;

        // Case 3: no dates → fallback to string sort
        return (a.subject || "").localeCompare(b.subject || "");
      },
      showSorterTooltip: { target: "sorter-icon" },
      sortDirections: ["ascend", "descend"],
      onCell: (record) => ({
        style: { width: "400px", cursor: "pointer" },
      }),
      render(value, record) {
        const isHighlighted = record.id == fileId;

        return (
          <p
            style={{
              maxWidth: "400px",
              color: theme.colors.black,
              backgroundColor: isHighlighted ? "#FFFF00" : "transparent",
              fontSize: "13px",
              opacity: isHighlighted ? 1 : 0.7,
              cursor: "pointer",
              marginBlock: "0px",
              paddingBlock: "0px",
              padding: "5px 0px 5px 0px",
              borderRadius: isHighlighted ? "5px" : "0px",
            }}
          >
            {value}
          </p>
        );
      },
    },
    {
      title: "Original File Name",
      dataIndex: "fileName",
      sorter: (a, b) => a.fileName.localeCompare(b.fileName),
      onCell: (record) => ({
        style: { width: "300px", cursor: "pointer" },
      }),
      render(value, record) {
        return <SC.ValueSpanP>{value}</SC.ValueSpanP>;
      },
    },
    /* {
      title: "File Date",
      dataIndex: "fileDate",
      sorter: (a, b) => new Date(a.fileDate) - new Date(b.fileDate),
      showSorterTooltip: { target: "sorter-icon" },
      sortDirections: ["ascend", "descend"],
      onCell: () => ({
        style: { width: "250px" },
      }),
      render(value, record, index) {
        return (
          <SC.ValueSpan>
            <TimezoneConverter time={value} format={"date"} />
          </SC.ValueSpan>
        );
      },
    }, */
    {
      title: "File Type",
      dataIndex: "fileType",
      onCell: () => ({
        style: { width: "100px" },
      }),
      render(value, record) {
        return <FileTypeIcon fileType={value} />;
      },
    },
    {
      title: "Size",
      dataIndex: "fileSize",
      sorter: (a, b) => parseFloat(a.fileSize) - parseFloat(b.fileSize),
      onCell: () => ({
        style: { width: "100px" },
      }),
      render(value, record, index) {
        return <>{formatFileSize(value)}</>;
      },
    },
    {
      title: "Modified Date & Time",
      dataIndex: "createdOn",
      sorter: (a, b) => new Date(a.createdOn) - new Date(b.createdOn),
      showSorterTooltip: { target: "sorter-icon" },
      sortDirections: ["ascend", "descend"],
      onCell: () => ({
        style: { width: "250px" },
      }),
      render(value, record, index) {
        return (
          <SC.ValueSpan>
            <TimezoneConverter time={value} />
          </SC.ValueSpan>
        );
      },
    },

    {
      title: "Sort Order",
      dataIndex: "sortOrder",
      // sorter: (a, b) => a.createdOn.localeCompare(b.createdOn),
      // showSorterTooltip: { target: "sorter-icon" },
      // sortDirections: ["ascend", "descend"],
      onCell: () => ({
        style: { width: "50px" },
      }),
      render(value, record, index) {
        return <SC.ValueSpan>{value}</SC.ValueSpan>;
      },
    },
  ];

  const tableConfig = {
    draggable: false,
    selection: hideButtons ? false : true,
    expandable: true,
    sno: false,
    addNew: false,
    pagination: {
      current: currentPage, // current page number
      pageSize: pageSize, // page size state
      // pageSizeOptions: ["20", "50", "100"], // options shown in the dropdown
      showSizeChanger: true, // enable page size dropdown
      onChange: (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize); // this is important to update
      },
    },
    search: false,
    action: false,
    divBorder: false,
  };

  const handleNewRevision = () => {
    setOpenModalView(true);
    setModalRowData(null);
  };

  const checkboxChangeCallback = (data, state) => {
    if (state === true) {
      selectedItems.unshift(data);
      setSelectedItems(selectedItems);
    } else {
      const newData = selectedItems.filter((item) => data !== item);
      setSelectedItems(newData);
    }
  };

  const allCheckboxChangeCallback = (data, state) => {
    if (state == true) {
      setSelectedItems(data);
    } else {
      setSelectedItems([]);
    }
  };

  const handleAddToCart = async () => {
    if (selectedItems.length === 0) {
      showAlert({
        title: "Warning",
        text: "Please select a file.",
        icon: "warning",
      });
      return;
    }
    const data = {
      id: currentProject.id,
      files: selectedItems,
    };
    dispatch(addCart(data));
    setSelectedItems([]);
  };

  return (
    <>
      <CustomBreadcrumb />
      <SC.BodyContainer>
        <SC.FilterContainer>
          <OccupantFilterDropdown />
        </SC.FilterContainer>
      </SC.BodyContainer>

      <CheckPermissionWrapper>
        {({ permission }) => (
          <>
            <SC.LeasingLayout>
              <GetPermission folderId={folderId} isLoading={isLoading} />
            </SC.LeasingLayout>

            <div
              style={{
                display: "flex",
                flex: 1,
                alignItems: "center",
                padding: "10px",
                borderBottom: `1px solid ${theme.colors.bordertask}`,
                justifyContent: "space-between",
              }}
            >
              <div style={{ gap: "10px", display: "flex" }}>
                <>
                  {permission >= userAccessType.write && (
                    <Button
                      caption={"+ New"}
                      onClick={handleNewRevision}
                      color="white"
                      fontSize="12px"
                      style={{
                        marginBottom: 8,
                        background: theme.gradient.themeGradient,
                        color: theme.colors.white,
                        minWidth: "100px",
                        height: "28px",
                        borderRadius: "3px",
                      }}
                    />
                  )}
                  {permission >= userAccessType.read && (
                    <Button
                      caption={"Add to cart"}
                      color={theme.colors.themeColor}
                      fontSize="12px"
                      style={{
                        marginBottom: 8,
                        minWidth: "90px",
                        height: "28px",
                        borderRadius: "3px",
                        border: `1px solid ${theme.colors.themeColor}`,
                      }}
                      onClick={handleAddToCart}
                    />
                  )}
                </>
              </div>
            </div>
            <SC.Container>
              <InnoTable
                tableConfig={tableConfig}
                loading={isLoading}
                padding="8px 8px"
                column={subColumnData}
                data={fileData}
                tableKey=""
                searchKeys={["propertyName", "displayTemplateName"]}
                onRowClickCallback={onRowClick}
                onAddDataCallback={onAddDataCallback}
                selectedItems={selectedItems}
                checkboxChangeCallback={checkboxChangeCallback}
                allCheckboxChangeCallback={allCheckboxChangeCallback}
                onRow={(record) => ({
                  onClick: (event) => {
                    if (
                      event.target.tagName === "INPUT" &&
                      event.target.type === "checkbox"
                    ) {
                      event.stopPropagation();
                      return;
                    }
                    setTimeout(() => {
                      if (!document.querySelector(".ant-image-preview-mask")) {
                        handlelevelClick(record);
                      }
                    }, 100);
                  },
                })}
              />
            </SC.Container>
          </>
        )}
      </CheckPermissionWrapper>

      {openModalView && (
        <AddUpdateRevision
          setOpenModalView={setOpenModalView}
          openModalView={openModalView}
          folderData={modalRowData}
          setModalRowData={setModalRowData}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          projectId={projectId}
          folderId={folderId}
          reloadData={getFileData}
          isAdding={true}
        />
      )}
    </>
  );
};

export default ListFileAndPermission;
